import { contentApi } from '@/infrastructure/Configuration'

export default class RoomService {
  constructor (httpClient) {
    this.httpClient = httpClient
  }

  async getRooms (hotelCode) {
    const url = `${contentApi}/hotels/${hotelCode}/rooms`
    const response = await this.httpClient.get(url)
    return response.data.rooms
  }
}
